<template>
    <div>
        <el-form :model="attributeForm" ref="ruleForm" label-width="70px" class="demo-ruleForm">
            <el-form-item
                v-for="(item, index) of attributeForm.attributeList"
                :key="index"
                :rules="
                    item.isRequired == 1
                        ? {
                              required: true,
                              message: item.spuNameKv.kvName + '不能为空',
                              trigger: 'blur'
                          }
                        : { required: false }
                "
                :prop="item.valueType == 1 ? 'attributeList.' + index + '.spuValue.value' : 'attributeList.' + index + '.spuValue.value'"
                :label="item.spuNameKv.kvName"
            >
                <el-input size="small" v-model="item.spuValue.value" :disabled="stateDisabled" v-if="item.valueType == 2"></el-input>

                <el-select v-if="item.valueType == 1" v-model="item.spuValue.value" :disabled="stateDisabled" size="small">
                    <el-option
                        v-for="(valueKv, index) of item.valueKvList"
                        :key="index"
                        :label="valueKv.kvName"
                        :value="valueKv.kvName"
                    ></el-option>
                </el-select>
                <!-- <el-button
                    style="margin-left: 10px"
                    v-if="item.valueType == 1"
                    size="small"
                    type="primary"

                    @click="addSpecifications(item)"
                    >添加到规格</el-button
                > -->
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import eventBus from '../../api/eventBus';
import { get, post, deleteFun } from '@/utils/request.js';

export default {
    data() {
        return {
            attributeForm: {
                spuNameKv: '',
                attributeList: []
            },

            rules: {},
            stateDisabled: false
        };
    },
    created() {
        eventBus.$on('spuList', (data, state) => {
            this.attributeForm.attributeList = JSON.parse(JSON.stringify(data));
            if (state == 'check') {
                this.stateDisabled = true;
            } else {
                this.stateDisabled = false;
            }
            // this.$forceUpdate();
            console.log(this.attributeForm.attributeList);
        });
    },
    beforeDestroy() {
        eventBus.$off('spuList');
    },
    methods: {
        validateForm() {
            let flag = true;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    flag = true;
                } else {
                    console.log('error submit!!');
                    flag = false;
                }
            });
            return flag;
        },

        addSpecifications(item) {
            item.disabled = 0;
            this.$forceUpdate();
            for (let element of item.valueKvList) {
                element.name = item.spuNameKv.kvName;
            }

            let obj = {
                kvName: item.spuNameKv.kvName,
                valueKv: item.valueKvList
            };
            console.log(this.attributeForm.attributeList);
            eventBus.$emit('Specification', obj);
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .el-input {
    width: 200px;
}
::v-deep .el-select {
    width: 200px;
}
</style>
